import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotiferService {

  private missionAnnouncedSource = new Subject<any>();

  missionConfirmed$ = this.missionAnnouncedSource.asObservable();

  notifer(mission: any) {
    this.missionAnnouncedSource.next(mission);
  }

}
